import { Box } from '@mantine/core';

/**
 * CyberBackground component provides a futuristic animated background with a moving grid and radial glow.
 * @param {Object} props - Component properties.
 * @param {React.ReactNode} props.children - Content to be displayed over the background.
 */
export default function CyberBackground({ children }) {
    return (
        <Box
            style={{
                position: 'relative',
                backgroundColor: '#0A0A0A',
                overflow: 'hidden',
            }}
        >
            <div style={{
                position: 'absolute',
                top: 0, left: 0, right: 0, bottom: 0,
                backgroundImage: `
          linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px),
          linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px)
        `,
                backgroundSize: '50px 50px',
                animation: 'moveGrid 20s linear infinite',
                zIndex: 0
            }} />

            <div style={{
                position: 'absolute',
                top: '10%', left: '50%',
                transform: 'translateX(-50%)',
                width: '800px', height: '800px',
                background: 'radial-gradient(circle, rgba(34, 139, 230, 0.15) 0%, transparent 70%)',
                zIndex: 0,
                pointerEvents: 'none'
            }} />

            <div style={{ position: 'relative', zIndex: 1 }}>
                {children}
            </div>

            <style>{`
        @keyframes moveGrid {
          0% { background-position: 0 0; }
          100% { background-position: 50px 50px; }
        }
      `}</style>
        </Box>
    );
}